export default {
    text: 'Products',
    path: '/product',
    icon: 'devices.svg',
    permissions: true, // show this category by default
    children: [
        {
            text: 'Event Groups',
            path: '/product/eventgroups',
            children: [],
            permissions: {
                EGROUP: 'READ'
            }
        },
        {
            text: 'CRM',
            path: '/product/crm',
            children: [],
            permissions: {
                UCONTACT: 'READ'
            }
        },
        {
            text: 'Broadcast Channels',
            path: '/product/channels',
            children: [],
            permissions: {
                BCHANNEL: 'READ'
            }
        },
        {
            text: 'Site Users',
            path: '/product/siteusers',
            children: [],
            permissions: {
                WSITE_USER: 'READ'
            }
        },
        {
            text: 'Message Apps',
            path: '/product/messaging',
            children: [],
            permissions: {
                ZMESSAGE_APPLICATION: 'READ'
            }
        },
        {
            text: 'Forms',
            path: '/product/forms',
            children: [],
            permissions: {
                WFORM: 'READ'
            }
        },
        {
            text: 'Event Management',
            path: '/product/events',
            children: [],
            permissions: {
                EMEVENT: 'READ'
            }
        },
        {
            text: 'Quizzes',
            path: '/product/quizzes',
            children: [],
            permissions: {
                QQUIZ: 'READ'
            }
        },
        {
            text: 'Applications',
            path: '/product/applications',
            children: [],
            permissions: {
                NAM_APP: 'READ'
            }
        },
        {
            text: 'Broadcasting',
            path: '/product/broadcasting',
            children: [],
            permissions: {
                BBROADCASTING: 'READ'
            }
        }
    ]
};
